import {FilterEmployee} from '@/app/modules/human-resources/employee/core/_models'
import {BaseResponse} from '@/_metronic/helpers/crud-helper/base-list-response'
import {BaseRequest} from '@/_metronic/helpers/crud-helper/base-request'
import {string} from 'yup'

export const initialFilterEmployee: BaseRequest<FilterEmployee> = {
  filter: {
    set_guid: false,
    guid: '',
    set_fullname: false,
    fullname: '',
    set_nickname: false,
    nickname: '',
    set_gender: false,
    gender: 'Laki-laki',
    set_marital: false,
    marital: 'Kawin',
    set_education: false,
    education: 'SMA',
    set_join_date: false,
    join_date: '',
    set_nik: false,
    nik: '',
    set_id_card: false,
    id_card: '',
    set_email: false,
    email: '',
    set_phone_number: false,
    phone_number: '',
    set_job_id: false,
    job_id: [],
    set_department_id: false,
    department_id: '',
    set_group_id: false,
    group_id: '',
    set_brand_id: false,
    brand_id: '',
    set_status: false,
    status: '',
    set_outlet_id: false,
    outlet_id: '',
    set_is_perbantuan: false,
    is_perbantuan: true,
    set_perbantuan_outlet_id: false,
    perbantuan_outlet_id: ""
  },
  limit: 50,
  page: 1,
  order: 'created_at',
  sort: 'DESC',
}

export type Employee = {
  job?: Job
  nik?: string
  job_id?: string
  job_name?: string
  join_date?: string
  department_id?: string
  department_name?: string
  guid?: string
  npwp?: string
  email?: string
  gender?: string
  outlet?: Outlet
  brand_id?: string
  group_id?: string
  outlet_id?: string
  brand_name?: string
  group_name?: string
  outlet_name?: string
  sub_brand_id?: string
  sub_brand_name?: string
  skills?: string[]
  status?: string
  id_card?: string
  about_me?: string
  fullname?: string
  nickname?: string
  bank_name?: string
  education?: string
  expertise?: string
  interests?: string
  created_at?: string
  created_by?: string
  updated_at?: string
  updated_by?: string
  cv_file_url?: string
  bank_account?: string
  phone_number?: string
  date_of_birth?: string
  marital_status?: string
  address_id_card?: string
  address_domicile?: string
  insurance_number?: string
  url_social_media: UrlSocialMedia
  url_profile_picture?: string
  bpjs_ketenagakerjaan?: string
  insurance_institution?: string
}

type UrlSocialMedia = {
  url?: string
  platform?: string
  usernames?: string
}

type Outlet = {
  brand_id?: string
  group_id?: string
  outlet_id?: string
  brand_name?: string
  group_name?: string
  outlet_name?: string
  sub_brand_id?: string
  sub_brand_name?: string
}

export type Job = {
  nik?: string
  job_id?: string
  job_name?: string
  join_date?: string
  department_id?: string
  department_name?: string
}

export type JobResponse = BaseResponse<Array<Employee>>
